module.exports = __webpack_public_path__ + "92293be325075211d442c26620582527.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_about_1@2x.png
// module id = 216
// module chunks = 1